<template>
  <AppDialog size="m"
             :cancelDisabled="cancelDisabled"
             :is-open="isOpen"
             :okDisabled="!canSend"
             :okLoading="okLoading"
             :okText="$t('common.send')"
             @cancel="cancel"
             @ok="send"
  >
    <template #title>{{ title }}</template>
    <template #body>
      <Alert no-icon :dismissible="false">
        {{ $t("common.dialogs.SendByEmailDialog.info") }}
      </Alert>

      <div class="my-3" style="max-height: 320px; overflow-y: auto">
        <div v-for="(_, index) in emailAddresses"
             :key="`item${index}`"
             class="d-flex align-center mt-3 ga-2"
        >
          <AppTextField
            v-model.trim="emailAddresses[index]"
            autofocus
            :placeholder="$t('common.emailAddress')"
          />
          <AppTooltip>
            <template #activator="{ props }">
              <app-button
                type="icon"
                size="small"
                v-bind="props"
                @click="() => removeEmailAddressAtIndex(index)"
              >
                <template #left-icon>
                  <app-material-icon name="close" />
                </template>
              </app-button>
            </template>
            <span>{{ $t('common.delete') }}</span>
          </AppTooltip>

        </div>
      </div>
      <app-button
        type="ghost"
        variant="neutral"
        class="d-flex align-center"
        color="primary"
        @click="addEmptyEmail"
      >
        <app-material-icon name="add" class="mr-2" />
        {{ $t('common.dialogs.SendByEmailDialog.addRecipient') }}
      </app-button>
    </template>
  </AppDialog>
</template>

<script>
import AppDialog from './AppDialog.vue'
import Alert from '../alerts/Alert.vue'
import AppTextField from '../AppTextField.vue'
import AppTooltip from '../AppTooltip.vue'

export default {
  name: 'SendByEmailDialog',
  components: { Alert, AppDialog, AppTextField, AppTooltip },
  props: {
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    okLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      emailAddresses: [''],
    }
  },
  computed: {
    canSend () {
      return this.notEmptyEmailAddresses.length > 0
    },
    notEmptyEmailAddresses () {
      return this.emailAddresses.filter(emailAddress => emailAddress !== '')
    },
  },
  methods: {
    addEmptyEmail () {
      this.emailAddresses.push('')
    },
    cancel () {
      this.$emit('cancel')
    },
    removeEmailAddressAtIndex (emailAddressIndex) {
      if (this.emailAddresses.length === 1) {
        this.emailAddresses = ['']
      } else {
        this.emailAddresses.splice(emailAddressIndex, 1)
      }
    },
    send () {
      this.$emit('send', this.notEmptyEmailAddresses)
    },
  },
}
</script>
